import { render } from "./PageUpdateCatatanDiskusi.vue?vue&type=template&id=0ebd1c33"
import script from "./PageUpdateCatatanDiskusi.vue?vue&type=script&lang=js"
export * from "./PageUpdateCatatanDiskusi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__